/** Figma greeting card when shown with space cards (LG/XL carousel). (1rem = 16px) */
export const GREETING_CARD_WIDTH = '14.5rem'; // 232px
export const GREETING_CARD_HEIGHT = '17rem'; // 272px — matches space card height

/**
 * Swiper `spaceBetween` is px-only (layout math). Use SPACE_CARD_GAP (rem) in CSS.
 */
export const SPACE_CARD_GAP_PX = 16;

/** Figma space card — identical across XS, SM, MD, LG, XL. (1rem = 16px) */
export const SPACE_CARD_WIDTH = '16.375rem'; // 262px
export const SPACE_CARD_HEIGHT = '17rem'; // 272px
export const SPACE_CARD_GAP = '1rem'; // 16px
export const SPACE_CARD_BORDER_RADIUS = '1.5rem'; // 24px
/** Figma space card surface — var(--AulaSky-900). Identical in light and dark. */
export const SPACE_CARD_BG = 'rgba(0, 91, 108, 1)';
/** Figma community space surface — var(--lightBlue-800). */
export const SPACE_COMMUNITY_CARD_BG = 'rgba(1, 84, 150, 1)';

/** Inner content frame inside space card padding (262 − 16×2). */
export const SPACE_CARD_INNER_WIDTH = '14.375rem'; // 230px
export const SPACE_CARD_INNER_HEIGHT = '15rem'; // 240px
export const SPACE_CARD_PADDING_Y = '1rem'; // 16px
export const SPACE_CARD_PADDING_X = '1rem'; // 16px
/** Gap between body block and resume button. */
export const SPACE_CARD_INNER_GAP = '0.75rem'; // 12px

export const SPACE_CARD_HEADER_ROW_HEIGHT = '2.5rem'; // 40px
export const SPACE_CARD_HEADER_ROW_GAP = '1rem'; // 16px

/** Title, description, and progress — excludes resume button. */
export const SPACE_CARD_BODY_BLOCK_HEIGHT = '12rem'; // 192px
export const SPACE_CARD_BODY_BLOCK_GAP = '0.5rem'; // 8px

/** Title + description wrapper, then progress — excludes resume button. */
export const SPACE_CARD_TEXT_BLOCK_HEIGHT = '9rem'; // 144px
export const SPACE_CARD_TEXT_BLOCK_GAP = '0.75rem'; // 12px
/** Title + description only (48 + 4 + 42). */
export const SPACE_CARD_TITLE_DESC_BLOCK_HEIGHT = '5.875rem'; // 94px
export const SPACE_CARD_TITLE_DESC_GAP = '0.25rem'; // 4px
export const SPACE_CARD_TITLE_HEIGHT = '3rem'; // 48px
export const SPACE_CARD_DESCRIPTION_HEIGHT = '2.625rem'; // 42px

export const SPACE_CARD_TITLE_FONT_SIZE = '1rem';
export const SPACE_CARD_TITLE_FONT_WEIGHT = 500;
export const SPACE_CARD_TITLE_LINE_HEIGHT = '150%';
export const SPACE_CARD_TITLE_LETTER_SPACING = '0.15px';

export const SPACE_CARD_DESCRIPTION_FONT_SIZE = '0.875rem';
export const SPACE_CARD_DESCRIPTION_FONT_WEIGHT = 400;
export const SPACE_CARD_DESCRIPTION_LINE_HEIGHT = '150%';
export const SPACE_CARD_DESCRIPTION_LETTER_SPACING = '0.17px';
/** Figma var(--text-secondary). */
export const SPACE_CARD_DESCRIPTION_COLOR = 'rgba(255, 255, 255, 0.7)';

export const SPACE_PROGRESS_BAR_HEIGHT = '0.5625rem'; // 9px
export const SPACE_PROGRESS_LABEL_HEIGHT = '1.3125rem'; // 21px
export const SPACE_PROGRESS_LABEL_FONT_SIZE = '0.875rem';
export const SPACE_PROGRESS_LABEL_LINE_HEIGHT = '150%';
export const SPACE_PROGRESS_LABEL_LETTER_SPACING = '0.17px';
export const SPACE_CARD_PROGRESS_SECTION_GAP = '0.5rem'; // 8px
/** 9 + 8 + 21 = 38px */
export const SPACE_CARD_PROGRESS_SECTION_HEIGHT = '2.375rem';

/** Figma educator engagement link — icon + "X% Active Students" + EastOutlined arrow. */
export const SPACE_ENGAGEMENT_LINK_WIDTH = '13.375rem'; // 214px
export const SPACE_ENGAGEMENT_LINK_HEIGHT = '2.5rem'; // 40px
export const SPACE_ENGAGEMENT_CONTENT_WIDTH = '10.875rem'; // 174px
export const SPACE_ENGAGEMENT_CONTENT_HEIGHT = '1.5rem'; // 24px
export const SPACE_ENGAGEMENT_CONTENT_GAP = '0.5rem'; // 8px
export const SPACE_ENGAGEMENT_ICON_SIZE = '1.5rem'; // 24px
export const SPACE_ENGAGEMENT_TEXT_WIDTH = '8.875rem'; // 142px
export const SPACE_ENGAGEMENT_TEXT_HEIGHT = '1.3125rem'; // 21px
export const SPACE_ENGAGEMENT_TEXT_FONT_SIZE = '0.875rem';
export const SPACE_ENGAGEMENT_TEXT_FONT_WEIGHT = 400;
export const SPACE_ENGAGEMENT_TEXT_LINE_HEIGHT = '150%';
export const SPACE_ENGAGEMENT_TEXT_LETTER_SPACING = '0.17px';
export const SPACE_ENGAGEMENT_TEXT_COLOR = 'rgba(255, 255, 255, 1)';

/** Figma educator empty-space prompt — shown when the space has no page/material. */
export const SPACE_EMPTY_PROMPT_WIDTH = '14.375rem'; // 230px
export const SPACE_EMPTY_PROMPT_HEIGHT = '2.25rem'; // 36px
export const SPACE_EMPTY_PROMPT_GAP = '0.5rem'; // 8px
export const SPACE_EMPTY_PROMPT_ICON_SIZE = '1.25rem'; // 20px
export const SPACE_EMPTY_PROMPT_TEXT_WIDTH = '12.1875rem'; // 195px
export const SPACE_EMPTY_PROMPT_TEXT_HEIGHT = '1.3125rem'; // 21px
export const SPACE_EMPTY_PROMPT_TEXT_FONT_SIZE = '0.875rem';
export const SPACE_EMPTY_PROMPT_TEXT_FONT_WEIGHT = 400;
export const SPACE_EMPTY_PROMPT_TEXT_LINE_HEIGHT = '150%';
export const SPACE_EMPTY_PROMPT_TEXT_LETTER_SPACING = '0.17px';
/** Figma var(--text-secondary). */
export const SPACE_EMPTY_PROMPT_TEXT_COLOR = 'rgba(255, 255, 255, 0.7)';
export const SPACE_EMPTY_PROMPT_EDUCATOR_LABEL = 'Start by adding a new page';
export const SPACE_EMPTY_PROMPT_STUDENT_LABEL = 'No materials found';

/** Figma --text-_states-focus */
export const SPACE_CARD_ICON_THUMBNAIL_BG = 'rgba(255, 255, 255, 0.12)';
/** MUI IconButton Color="Default" on dark — not full white. */
export const SPACE_CARD_ICON_GLYPH_COLOR = 'rgba(255, 255, 255, 0.56)';

export const SPACE_CARD_SHADOW = '0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08)'; // 0 8px 16px

export const SPACE_CARD_ICON_BUTTON_SIZE = '2.5rem'; // 40px
export const SPACE_CARD_ICON_BUTTON_PADDING = '0.5rem'; // 8px
export const SPACE_CARD_ICON_BUTTON_RADIUS = '6.25rem'; // 100px
export const SPACE_CARD_ICON_GLYPH_SIZE = '1.5rem'; // 24px
export const SPACE_CARD_ICON_FOCUS_RIPPLE_SIZE = '2.5rem'; // 40px
export const SPACE_CARD_ICON_FOCUS_RIPPLE_BG = 'rgba(255, 255, 255, 0.12)';

export const SPACE_META_PILL_HEIGHT = '1.5rem'; // 24px
export const SPACE_META_PILL_RADIUS = '6.25rem'; // 100px
/**
 * Figma Chip root horizontal padding 4px.
 * Vertical padding is via centering 21px label (150%) inside 24px — not extra py
 * (3+21+3 would exceed 24 with border-box).
 */
export const SPACE_META_PILL_PADDING_X = '0.25rem'; // 4px
/** Figma Chip label horizontal padding — 6px. */
export const SPACE_META_PILL_LABEL_PADDING_X = '0.375rem'; // 6px
export const SPACE_META_PILL_FONT_SIZE = '0.875rem';
/** Figma label line-height 150% (= 21px). */
export const SPACE_META_PILL_LINE_HEIGHT = '150%';
export const SPACE_META_PILL_LETTER_SPACING = '0.17px';
export const SPACE_META_PILL_GAP = '0.25rem'; // 4px
export const SPACE_META_PILLS_CONTAINER_WIDTH = '10.875rem'; // 174px
export const SPACE_META_PILLS_CONTAINER_HEIGHT = '1.5rem'; // 24px

/** Figma resume button — Medium / Outlined. */
export const SPACE_RESUME_BUTTON_HEIGHT = '2.25rem'; // 36px
export const SPACE_RESUME_BUTTON_PADDING = '0.375rem 1rem'; // 6px 16px
export const SPACE_RESUME_BUTTON_FONT_SIZE = '0.875rem';
export const SPACE_RESUME_BUTTON_LINE_HEIGHT = '150%';
export const SPACE_RESUME_BUTTON_LETTER_SPACING = '0.17px';
export const SPACE_RESUME_BUTTON_ICON_SIZE = '1.25rem'; // 20px
export const SPACE_RESUME_BUTTON_GAP = '0.5rem'; // 8px
export const SPACE_RESUME_BUTTON_LABEL = 'Resume';
/** Shown to students on hover/focus and to screen readers when nothing can be resumed. */
export const SPACE_RESUME_DISABLED_LABEL = 'No materials to resume yet';

/** Figma Frame 14757 — Space widget container (XL/LG). Width is 100% of parent. */
export const SPACE_WIDGET_CONTAINER_MIN_HEIGHT = '22.1875rem'; // 355px
export const SPACE_WIDGET_CONTAINER_BORDER_RADIUS = '1.5rem'; // 24px
export const SPACE_WIDGET_CONTAINER_PADDING = '1rem'; // 16px
export const SPACE_WIDGET_CONTAINER_GAP = '0.625rem'; // 10px
export const SPACE_WIDGET_CONTAINER_BORDER_LIGHT =
  '1px solid rgba(35, 31, 41, 0.16)';
export const SPACE_WIDGET_CONTAINER_BORDER_DARK =
  '1px solid rgba(255, 255, 255, 0.12)';
export const SPACE_WIDGET_CONTAINER_BG_LIGHT = '#FFFFFF';
/** Figma dark — widget frame surface var(--surface-Bright, rgba(58, 52, 68, 1)). */
export const SPACE_WIDGET_CONTAINER_BG_DARK = 'rgba(58, 52, 68, 1)';

/** Min role-filtered cards before auto-prefetch stops (carousel can scroll). */
export const SPACE_WIDGET_PREFETCH_MIN_VISIBLE_CARDS_LG = 5;
export const SPACE_WIDGET_PREFETCH_MIN_VISIBLE_CARDS_SM = 3;

/** Start loading the next page when this many slides remain ahead of the viewport. */
export const SPACE_WIDGET_SCROLL_PREFETCH_REMAINING_SLIDES = 5;

/** Skeleton card count while initial spaces API load is in flight (Figma loading state). */
export const SPACE_WIDGET_SKELETON_CARD_COUNT_LG = 4;
export const SPACE_WIDGET_SKELETON_CARD_COUNT_SM = 3;

/** Failed pagination attempts at the same cursor before showing the error card at carousel end. */
export const SPACE_WIDGET_PAGINATION_ERROR_THRESHOLD = 2;

/** Skeleton shimmer on teal space cards — works in light and dark app chrome. */
export const SPACE_CARD_SKELETON_SURFACE = 'rgba(255, 255, 255, 0.22)';

/** Figma error card — same footprint and padding as a space card. */
/** Inner frame vertical padding (240 − 35×2 = 170px content band). */
export const SPACE_WIDGET_ERROR_INNER_PADDING_Y = '2.1875rem'; // 35px
/** Outer card padding + inner padding (16 + 35). */
export const SPACE_WIDGET_ERROR_OFFSET_FROM_CARD_TOP = '3.1875rem'; // 51px
export const SPACE_WIDGET_ERROR_CONTENT_BAND_HEIGHT = '10.625rem'; // 170px
/** Gap between icon, message, and retry button. */
export const SPACE_WIDGET_ERROR_CONTENT_GAP = '1rem'; // 16px
export const SPACE_WIDGET_ERROR_ICON_SIZE = '1.5rem'; // 24px
export const SPACE_WIDGET_ERROR_MESSAGE_HEIGHT = '2.625rem'; // 42px
export const SPACE_WIDGET_ERROR_MESSAGE_FONT_SIZE = '0.875rem';
export const SPACE_WIDGET_ERROR_MESSAGE_FONT_WEIGHT = 400;
export const SPACE_WIDGET_ERROR_MESSAGE_LINE_HEIGHT = '150%';
export const SPACE_WIDGET_ERROR_MESSAGE_LETTER_SPACING = '0.17px';
export const SPACE_WIDGET_ERROR_BUTTON_ROW_HEIGHT = '1.875rem'; // 30px
export const SPACE_WIDGET_ERROR_RETRY_HEIGHT = '1.875rem'; // 30px
export const SPACE_WIDGET_ERROR_RETRY_PADDING = '0.25rem 0.625rem'; // 4px 10px
export const SPACE_WIDGET_ERROR_RETRY_FONT_SIZE = '0.8125rem';
export const SPACE_WIDGET_ERROR_RETRY_FONT_WEIGHT = 500;
export const SPACE_WIDGET_ERROR_RETRY_LINE_HEIGHT = '1.375rem'; // 22px
export const SPACE_WIDGET_ERROR_RETRY_LETTER_SPACING = '0px';
export const SPACE_WIDGET_ERROR_API_MESSAGE =
  "We couldn't load this information right now.";
export const SPACE_WIDGET_ERROR_NETWORK_MESSAGE =
  'Check your internet connection and try again.';
export const SPACE_WIDGET_ERROR_RETRY_LABEL = 'Retry';
/** Figma var(--text-secondary). */
export const SPACE_WIDGET_ERROR_MESSAGE_COLOR = 'rgba(255, 255, 255, 0.7)';
/** Figma var(--primary-main). */
export const SPACE_WIDGET_ERROR_RETRY_BG = 'rgba(208, 188, 250, 1)';
/** Figma var(--primary-contrastText). */
export const SPACE_WIDGET_ERROR_RETRY_TEXT = 'rgba(35, 2, 84, 1)';

/** Figma empty state — compact "No module found" card (greeting moves above on all breakpoints). */
export const SPACE_WIDGET_EMPTY_STATE_MIN_HEIGHT = '5.3125rem'; // 85px
export const SPACE_WIDGET_EMPTY_STATE_TITLE = 'No module found';
export const SPACE_WIDGET_EMPTY_STATE_SUBTITLE =
  "You're not enrolled in any space.";
/** Figma var(--surface-Mid) — light. */
export const SPACE_WIDGET_EMPTY_STATE_BG_LIGHT = 'rgba(248, 247, 249, 1)';
/** Figma var(--surface-Mid) — dark. */
export const SPACE_WIDGET_EMPTY_STATE_BG_DARK = 'rgba(35, 31, 41, 1)';
